import { useState, useEffect } from "react";
import { Container, Icon } from "semantic-ui-react";
import styled from "styled-components";

const SlideWrapper = styled(Container)`
    margin: 2rem auto;
`;

const DotContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 1rem;
`;

type CarouselProps = {
    slides: JSX.Element[];
    stopCarouselRefresh: boolean;
};

const Carousel = ({ slides, stopCarouselRefresh }: CarouselProps) => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        if (stopCarouselRefresh) {
            return;
        }

        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [slides.length, stopCarouselRefresh]);

    return slides.length === 0 ? null : (
        <SlideWrapper>
            {slides[index]}
            <DotContainer style={{ display: slides.length > 1 ? "flex" : "none" }}>
                {slides.map((_, i) => (
                    <Icon
                        key={i}
                        name="circle"
                        size="small"
                        color={i === index ? "blue" : "grey"}
                        onClick={() => setIndex(i)}
                        style={{ cursor: "pointer" }}
                        data-testid={`carousel-dots-${i}`}
                    />
                ))}
            </DotContainer>
        </SlideWrapper>
    );
};

export default Carousel;
